export const FILTER_AND_SEARCH_REDUCER_REPORTS_STATE_ID =
  'filterAndSearchReports';
export const FILTERING_REDUCER_REPORTS_STATE_ID = 'filteringReports';
export const RESULT_REDUCER_REPORTS_STATE_ID = 'resultReports';
export const REPORTS_REDUCER_STATE_ID = 'reports';
export const DEFAULT_REPORTS_PAGE_SIZE = 10;
export const ROUTE_REPORTS = '/reports';

export const REPORTS_SEARCH_COMPONENTS = {
  reports: false,
  filter: false,
};

export const DEFAULT_REPORTS_WATCH_LOCATION_PARAM_KEYS = ['filter'];
